export default __webpack_public_path__ + "static/media/moneyout.50ac9bcd.svg";